export const getTypeTitle = ( type: number | string) => {
    switch (Number(type)) {
        case 0:
            return "Other";
        case 1:
            return "Cash Management";
        case 2:
            return "Legal";
        default:
            return "-";
    }
}
export const getStatus = (status: number) => {
    switch(status){
        case 0:
            return "Open";
        case 1:
            return "Closed";
        case 2:
            return "Complete";
        default:
            return "-";

    }
}